<div class="container">
  <div style="text-align: center">
    <p class="content">
      You've exceeded the maximum number of goals.<br /><br />
      Please review and select up to 10 to continue
    </p>
    <button mat-button class="back-btn" (click)="onClose()">close</button>
  </div>
</div>
